export default {

    //заполнить данные для графика активаций
    loadChartData(state, data) {
        state.activatesData = data;
    },

    //заполнить сводку по активациям
    loadSummary({commit}, data){
        state.activatesSummary=data
    },

    //заполнить данные по популярным партнерам
    loadPopPartners(state, data) {
        state.popPartners = data;
    },

    //заполнить данные по популярным клиентам
    loadPopClients(state, data) {
        state.popClients = data;
    },

    //заполнить данные по активациям
    loadActivatesList(state, data) {
        state.activatesList = data;
    },


}
